import { CodedResultError, getResultErrorCode } from './coded-result.error';
import { SubmissionErrorCode } from './submission-error-code';

/** Represents an HTTP 422 response from a domain API. */
export class UnprocessableEntityResultError<T = unknown> extends CodedResultError<T> {}

const SUBMISSION_BANNED_MESSAGE = 'Submission has been banned';

export const isSubmissionBannedResultError = (error: unknown): boolean => {
  if (getResultErrorCode(error) === SubmissionErrorCode.banned) return true;
  if (!(error instanceof UnprocessableEntityResultError)) {
    return false;
  }

  const message = error.error instanceof Error ? error.error.message : String(error.error ?? '');
  return message === SUBMISSION_BANNED_MESSAGE;
};
